import { gql } from '@apollo/client'
import { Breadcrumb, Pagination } from 'antd'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'src/utils/i18n'
import { logQuery } from 'src/utils/apollo'
import Bottom from 'src/components/guide/Bottom'
import Header from 'src/components/guide/Header'
import styles from './index.module.scss'

const Search = () => {
  const { t, locale } = useTranslation('common')
  const router = useRouter()
  const [current, setCurrent] = useState(1)
  const pageSize = useMemo(() => 10, [])
  const [total, setTotal] = useState(0)
  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const inputDom = useRef(null)

  useEffect(() => {
    let ios = 'ios-guide'
    let android = 'android-guide'
    if (locale && locale != 'en') {
      if (locale == 'it-ch') {
        ios = ios + '-it'
        android = android + '-it'
      } else {
        ios = ios + '-' + locale
        android = android + '-' + locale
      }
    }

    logQuery({
      query: gql`
          query {
            tsafelyArticles(
              filters: { title: { containsi: "${router.query.query}" }, tsafely_category: { name: { in: ["${ios}", "${android}"] } } }
              pagination: { page: ${current}, pageSize: ${pageSize} }
              sort: "updatedAt:desc"
            ) {
              data {
                id
                attributes {
                  title
                  slug
                }
              }
              meta {
                pagination {
                  page
                  pageSize
                  pageCount
                  total
                }
              }
            }
          }
        `
    }).then(res => {
      setData(res.data.tsafelyArticles.data)
      setTotal(res.data.tsafelyArticles.meta.pagination.total)
    })
    console.log('router.query.query', router.query.query)
  }, [current, pageSize, locale, router.query.query])

  const onEnter = event => {
    if (event.key === 'Enter') {
      router.push('/guide/search?query=' + searchText)
      inputDom.current.blur()
    }
  }

  const onChange = page => {
    setCurrent(page)
  }

  return (
    <>
      <Header />
      <main className='max-w-[1200px] min-h-[calc(var(--vh)*100-380px)] mx-auto Bld:min-h-[calc(var(--vh)*100-360px)] Bxl:px-[16px] py-[20px]'>
        <div className='w-full flex Bld:flex-col justify-between items-center Bld:items-start'>
          <Breadcrumb
            items={[
              {
                title: <Link href='/guide'>{t('Guide')}</Link>
              },
              {
                title: t('Search')
              }
            ]}
          />
          <div className='w-[300px] Bld:w-full Bld:mt-[10px] h-[40px] bg-[#FFF] border border-[rbg(121,121,121)] rounded-[41px] outline-none px-[24px] flex items-center'>
            <Image src='/images/contacts/search.svg' width={20} height={0} alt='search' />
            <input
              ref={inputDom}
              className='ml-[10px] flex-1 outline-none placeholder:text-[rgb(129,129,135)]'
              placeholder={t('Search')}
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              onKeyPress={onEnter}
            />
          </div>
        </div>
        <h1 className='mt-[45px] text-[32px]'>{t('Search results')}</h1>
        <p className='text-[15px] text-[rgba(42,49,61,1)] mt-[10px]'>
          {total} {t('results for')} "{router.query.query}"
        </p>
        <div className='mt-[20px] flex flex-col Blds:w-[500px]'>
          {data.map((item, i) => (
            <div key={i} className='py-[20px] border-b'>
              <Link
                href={'/guide/' + item.attributes.slug}
                className='text-[16px] Bld:text-[15px] text-[#222] hover:text-[#2a99ff] cursor-pointer'
              >
                {item.attributes.title}
              </Link>
            </div>
          ))}
          {total !== 0 && (
            <Pagination
              className={`${styles.pagination} mt-[30px]`}
              current={current}
              pageSize={pageSize}
              total={total}
              onChange={onChange}
            />
          )}
        </div>
      </main>
      <Bottom />
    </>
  )
}

export default Search